import React, { useState, useEffect, Fragment } from 'react';
import { isMobile } from 'react-device-detect';
import { Link, withRouter } from '#/renderer/router';
import { hookstate } from '@hookstate/core';
import $ from 'jquery';
import useStores from '~/store/StoreHook';

//import blukai, removido
import { useQueryString } from '#/renderer/usePageContext';

export const activeCategory = hookstate();

const ArrowLeft = ({
  color = '#3e3e3e',
  fontSize = '20px',
}) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false" className="rs-icon" aria-label="arrow right line" style={{ fontSize, color }}>
    <path d="M6.293 10.293L8.585 8 6.293 5.707a.999.999 0 111.414-1.414l3 3a.99.99 0 01.277.531l.014.117v.118a.997.997 0 01-.291.648l-3 3a.999.999 0 11-1.414-1.414z"></path>
  </svg>
)

const ArrowDown = ({
  color = '#3e3e3e',
  fontSize = '20px',
}) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false" className="rs-icon" aria-label="arrow down line" data-category="direction" style={{ fontSize, color }}>
    <path d="M8 11a.997.997 0 01-.707-.293l-3-3a.999.999 0 111.414-1.414L8 8.586l2.293-2.293a.999.999 0 111.414 1.414l-3 3A.997.997 0 018 11z"></path>
  </svg>
)

const ArrowDownButton = ({
  isMobile = false,
  openMacroCategoriesByCategory = () => { },
  selected
}) => {

  if (isMobile && !selected) {
    return <></>
  }

  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      // onMouseEnter={openMacroCategoriesByCategory}
      onClick={openMacroCategoriesByCategory}
    >
      <ArrowDown fontSize="24px" color="#757575" />
    </div>
  )

}

const ArrowLeftButton = ({
  isMobile = false,
  openMacroCategoriesByCategory = () => { },
  selected
}) => {

  if (isMobile && !selected) {
    return <></>
  }

  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      // onMouseEnter={openMacroCategoriesByCategory}
      onClick={openMacroCategoriesByCategory}
    >
      <ArrowLeft fontSize="24px" color="#757575" />
    </div>
  )

}

const MacroCategoryDiv = withRouter(({
  item,
  keys,
  toggleSelected,
  categorySlug,
  isMobile,
  showCategoriesBySlug = () => { },
  selectedSlugToShowOptions = null,
  categoriesBySlug = [],
  setSelectedSlugToShowOptions = () => { },
  facetID = null,
  canApplyFilterAsSubMenu = false,
  categoryFilterAsSubMenu = null,
  history,
}) => {

  const { facets } = useStores();

  const [ facetsList, setFacetsList ] = React.useState([]);
  const [selected, setSelected] = useState("");

  function facetsView() {
    facets.allFacets(facetID)
    .then((res) => { setFacetsList(res.data) });
  }

  React.useEffect(() => {
    if (canApplyFilterAsSubMenu && facetID) {
      facetsView();
    }
  }, [facetID, canApplyFilterAsSubMenu]);

  useEffect(() => {
    if (categorySlug?.indexOf(item.external_referrer) >= 0) {
      setSelected('active');
      activeCategory.set(item);
    }
  }, [categorySlug, item]);

  const ocultarMenuCategorias = () => {
    $(".nav--grid").slideToggle();
  };

  const onSelectNavCategory = () => {
    sessionStorage.clear();
    //blukai function, removida

    toggleSelected(keys);
    history.push(`/categories/${item.external_referrer}`);
  }

  const localeItem = item.locales[process.env.NEXT_PUBLIC_LOCALE];
  const itemSlug = localeItem.slug;
  const showSubmenu =
    categoriesBySlug.find((category) => category.slug === itemSlug)?.categories.length > 0 &&
    !item.contract &&
    !item.display;

  if (selectedSlugToShowOptions && isMobile) {

    return (
      <div style={{ display: 'flex', flexDirection: 'column', position: !isMobile ? 'relative' : '' }}>
        <RenderSlugCategoriesList itemSlug={itemSlug} categories={categoriesBySlug} selected={selected} setSelectedSlugToShowOptions={setSelectedSlugToShowOptions} facets={facetsList} categoryFilterAsSubMenu={categoryFilterAsSubMenu}/>
      </div>
    )

  }

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: !isMobile ? 'relative' : '' }}>
      <div
        className="nav--category"
        onClick={ () => !isMobile && showSubmenu && (!selectedSlugToShowOptions  || itemSlug !== selectedSlugToShowOptions ) ? showCategoriesBySlug(itemSlug) : onSelectNavCategory()}
      >

        <img
          src={`${process.env.NEXT_PUBLIC_ESPOTS}/macro_category/${item.external_referrer.replace(/\//g, "_")}${selected ? "_active" : ""}.png`}
          alt="macro category"
        />
        <span
          key={`${keys}-span`}
          className={`nav--category-box buttonDesktop ${selected}`}
          id={keys}
          style={{ marginRight: !isMobile ? '4px' : '' }}
        >
          {item.locales[process.env.NEXT_PUBLIC_LOCALE].name}
        </span>
        <span
          id={keys}
          key={`${keys}-span-mobile`}
          className={`nav--category-box buttonResponsive ${selected}`}
          onClick={() => ocultarMenuCategorias()}

        >
          {item.locales[process.env.NEXT_PUBLIC_LOCALE].name}
        </span>

      </div>
      {
        !isMobile && showSubmenu && (
          <ArrowDownButton
            openMacroCategoriesByCategory={() => showCategoriesBySlug(itemSlug)}
            />
        )
      }

      {
        isMobile && selected !== '' && showSubmenu && (
          <ArrowLeftButton
            openMacroCategoriesByCategory={() => showCategoriesBySlug(itemSlug)}
          />
        )
      }

      {
        selectedSlugToShowOptions === itemSlug && !isMobile && (
          <RenderSlugCategories itemSlug={itemSlug} categories={categoriesBySlug}
          setSelectedSlugToShowOptions={setSelectedSlugToShowOptions} facets={facetsList} categoryFilterAsSubMenu={categoryFilterAsSubMenu}
          />
        )
      }


    </div>

  );
});


const ocultarMenuCategorias = () => {
  $(".nav--grid").slideToggle();
};


const RenderMacroCategories = ({
  macroCategories,
  toggleSelected,
  renovaciones,
  categorySlug,
  isMobile,
  showCategoriesBySlug = () => { },
  selectedSlugToShowOptions = null,
  categoriesBySlug = [],
  setSelectedSlugToShowOptions = () => { },
  faceFilterAsSubmenu = {},
}) => {

  const items = (macroCategories.data || []).map((v, i) => {

    const itemCategorySlug = v.external_referrer;
    const keys = `category-box-${i}`;
    const categoryFacetFilterAsSubmenu = faceFilterAsSubmenu?.[itemCategorySlug] ?? false;
    const categoryFilterAsSubMenu = faceFilterAsSubmenu?.[`${itemCategorySlug}_filter_as_sub_menu`] ?? null;

    const canApplyFilterAsSubMenu = categoryFacetFilterAsSubmenu === true && categoryFilterAsSubMenu !== null;

    const facetID = !categoryFacetFilterAsSubmenu ? null : (v.external_referer ?? null);

    return (
      <MacroCategoryDiv
        item={v}
        key={keys}
        keys={keys}
        toggleSelected={toggleSelected}
        categorySlug={categorySlug}
        isMobile={isMobile}
        showCategoriesBySlug={showCategoriesBySlug}
        selectedSlugToShowOptions={selectedSlugToShowOptions}
        categoriesBySlug={categoriesBySlug}
        setSelectedSlugToShowOptions={setSelectedSlugToShowOptions}
        facetID={canApplyFilterAsSubMenu ? facetID : null}
        canApplyFilterAsSubMenu={canApplyFilterAsSubMenu}
        categoryFilterAsSubMenu={canApplyFilterAsSubMenu ? categoryFilterAsSubMenu : null}
      />
    );
  });



  const recom = ((renovaciones  && !isMobile) || ( renovaciones && isMobile && !selectedSlugToShowOptions )) ? (
    <div className="nav--category" onClick={() => ocultarMenuCategorias()}>
      <img
        src={`${process.env.NEXT_PUBLIC_ESPOTS}/macro_category/renovaciones.png`}
        alt="recom"
      />
      <Link className="nav--category-box buttonDesktop" onClick={() => {
        //blukai function, removida
      }} to={renovaciones.link}>
        {renovaciones.texto}
      </Link>
      <span className="nav--category-box buttonResponsive">
        <Link to={renovaciones.link}>
          {renovaciones.texto}
        </Link>
      </span>
    </div>
  ) : null;

  let className = "grid nav--grid"
  if( selectedSlugToShowOptions && isMobile ) {
    className = "grid nav--grid full"
  }


  return (

    <div className={className}>
      {items}
      {recom}
    </div>

  )

}

const RenderSlugCategories = withRouter((props) => {

  console.log('props', props)

  const {
    itemSlug,
    categories,
    facets,
    categoryFilterAsSubMenu
  } = props

  const facetsList = facets ?? [];

  const { setQueryString } = useQueryString();


  if (facetsList.length > 0) {

    const onSelectFacetItem = (facetID) => {

      const query = new URLSearchParams();
      query.append('filter', facetID);
      props.setSelectedSlugToShowOptions(null);
      props.history.push({ pathname: `/categories/${itemSlug}`, search: query.toString() });
      setQueryString(new Date().getTime());

    }

    const equipmentFacets = facetsList.find(x => x.identifier === categoryFilterAsSubMenu)?.atrributes ?? [];

    return (
      <React.Fragment>
      <div className="floatingMenuarrow"></div>
      <div className="floatingMenu">
        {
          equipmentFacets.map((cat, index) => (
            <div
              key={`marca-${index}`}
              className="floatingMenu__item"
              onClick={() => onSelectFacetItem(cat.facetId)}
            >
              {cat.label}
            </div>
          ))
        }
      </div>
      </React.Fragment>
    )

  }

  const catToRender = categories.find(x => x.slug === itemSlug)?.categories || [];

  const pushToHistory = (slug) => {
    props.setSelectedSlugToShowOptions(null);
    props.history.push(`/categories/${slug}`);
  }

  return (
    <React.Fragment>
      <div className="floatingMenuarrow"></div>
      <div className="floatingMenu">
        {
          catToRender.map((cat, index) => (
            <div
              key={`marca-${index}`}
              className="floatingMenu__item"
              onClick={() => pushToHistory(cat.slug)}
            >
              {cat.name}
            </div>
          ))
        }
      </div>
    </React.Fragment>

  )

})

const RenderSlugCategoriesList = withRouter((props) => {


  const {
    itemSlug,
    categories,
    selected,
    facets,
    categoryFilterAsSubMenu
  } = props

  if (selected === '') {
    return <></>
  }

  const facetsList = facets ?? [];

  const { setQueryString } = useQueryString();

  if (facetsList.length > 0) {

    const onSelectFacetItem = (facetID) => {

      $(".nav--grid").slideToggle();
      props.setSelectedSlugToShowOptions(null);

      const query = new URLSearchParams();
      query.append('filter', facetID);
      props.history.push({ pathname: `/categories/${itemSlug}`, search: query.toString() });
      setQueryString(new Date().getTime());

    }

    const equipmentFacets = facetsList.find(x => x.identifier === categoryFilterAsSubMenu)?.atrributes ?? [];

    return (
      <React.Fragment>
        {
          equipmentFacets.map((cat, index) => (
            <div
              key={`marca-${index}`}
              className="floatingMenu__item"
              onClick={() => onSelectFacetItem(cat.facetId)}
            >
              {cat.label}
            </div>
          ))
        }
      </React.Fragment>
    )

  }



  const catToRender = categories.find(x => x.slug === itemSlug)?.categories || [];


  const pushToHistory = (slug) => {
    $(".nav--grid").slideToggle();
    props.setSelectedSlugToShowOptions(null);
    props.history.push(`/categories/${slug}`);
  }

  return (
    <React.Fragment>
        {
          catToRender.map((cat, index) => (
            <div
              key={`marca-${index}`}
              className="floatingMenu__item"
              onClick={() => pushToHistory(cat.slug)}
            >
              {cat.name}
            </div>
          ))
        }
    </React.Fragment>

  )

})

const MacroCategoriesGridUI = ({
  macroCategories,
  toggleSelected,
  renovaciones,
  categorySlug,
  categories = [],
  faceFilterAsSubmenu = {},
}) => {

  const macroCategoriesList = (macroCategories?.data || []);

  const [selectedSlugToShowOptions, setSelectedSlugToShowOptions] = useState(null);

  const [ categoriesBySlug, setCategoriesBySlug ] = useState([]);

  // execute only first time
  useEffect(() => {
    let catDisplay = null;
    const slugs = macroCategoriesList.map((x) => {
      if (x.display) {
        catDisplay = x.external_referrer;
      }
      return x.locales[process.env.NEXT_PUBLIC_LOCALE].categories.find(n => n.level === 2).slug;
    });

    if (!categories.length) {
      return;
    }

    // const categoriesBySlug = slugs.map(s => {

    //   const r = categories
    //     .map(x => x.locales.es_gt.categories)
    //     .filter(x => x?.map(n => n.slug)?.includes(s))
    //     .map(x => x.filter(n => n.level === 3))
    //     .map(x => x.map(n => n))
    //     .reduce((cv, acc) => [...cv, ...acc], [])

    //   const uniqueCategories = r.filter((obj, index, self) => {
    //     return index === self.findIndex(t => t.slug === obj.slug)
    //   }).sort((a, b) => a.name.localeCompare(b.name));

    //   return {
    //     slug: s,
    //     categories: uniqueCategories
    //   }

    // })

    const categoriesBySlug = slugs.map(s => {

      const uniqueCategories = categories
        .filter(category => category.locales[process.env.NEXT_PUBLIC_LOCALE].parent_code === s && s !== catDisplay)
        .map((filteredCategories) => {

            const name = filteredCategories.locales[process.env.NEXT_PUBLIC_LOCALE].name
            const slug = `${filteredCategories.external_referrer}`

            return { name, slug }
        }).sort((a, b) => a.name.localeCompare(b.name));

        return {
          slug: s,
          categories: uniqueCategories
        }
    })

    setCategoriesBySlug(categoriesBySlug);

  }, [categories]);

  if (!macroCategories) {
    return false;
  }


  const showCategoriesBySlug = (slug) => {


    if (selectedSlugToShowOptions === slug) {
      setSelectedSlugToShowOptions(null);
      return false;
    }

    setSelectedSlugToShowOptions(slug);

    // verMenuCategorias();

  }



  const verMenuCategorias = () => {

    console.log('verMenuCategorias');
    const navGrid = $(".nav--grid");
    navGrid.toggleClass("active");
    navGrid.slideToggle();

    setTimeout(() => {
      setSelectedSlugToShowOptions(null);
    }, 800);
  };


  return (
    <div className="menuResponsive">

      <button type="button"
      onClick={() => verMenuCategorias()}
      >
        {activeCategory.value && (
          <img
            src={`${process.env.NEXT_PUBLIC_ESPOTS}/macro_category/${activeCategory.external_referrer?.value?.replace(/\//g, "_")}_active.png`}
            alt="macro category"
          />
        )}
        <span>
          {activeCategory?.locales?.[process.env.NEXT_PUBLIC_LOCALE]?.name.value}
        </span>
      </button>


      <RenderMacroCategories
        macroCategories={macroCategories}
        toggleSelected={() => {
          toggleSelected();
          setSelectedSlugToShowOptions(null);
        }}
        renovaciones={renovaciones}
        categorySlug={categorySlug}
        isMobile={isMobile}
        showCategoriesBySlug={showCategoriesBySlug}
        selectedSlugToShowOptions={selectedSlugToShowOptions}
        categoriesBySlug={categoriesBySlug}
        setSelectedSlugToShowOptions={setSelectedSlugToShowOptions}
        faceFilterAsSubmenu={faceFilterAsSubmenu}
      />


    </div>
  );

};


export default MacroCategoriesGridUI;
